






























import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
class PageUserloginattemptRequest extends PageRequest {
  FilterText: string;
}
class PageCompanyRequest{
  cId:Number;
}
@Component({
  components: { },
})
export default class Equipments extends AbpBase {
  pagerequest: PageUserloginattemptRequest = new PageUserloginattemptRequest();
  publicpagerequest: PageUserloginattemptRequest = new PageUserloginattemptRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  userName: string;
  cId:Number;
  get list() {
    return this.$store.state.userloginattempt.list;
  }
  get loading() {
    return this.$store.state.userloginattempt.loading;
  }
  pageChange(page: number) {
    this.$store.commit("userloginattempt/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("userloginattempt/setPageSize", pagesize);
    this.getpage();
  }

  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getpage();
  }
  async getpage() {
     this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "userloginattempt/getPaged",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.userloginattempt.pageSize;
  }
  get totalCount() {
    return this.$store.state.userloginattempt.totalCount;
  }
  get currentPage() {
    return this.$store.state.userloginattempt.currentPage;
  }
  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  columns = [
    // {
    //   title: "所属公司",
    //   key: "cId",
    //   render: (h, params) => {
    //     let cId = params.row.cId;
    //     let clist = this.companylist();
    //     for (let entry of clist) {
    //       //console.log(entry.id); // 1, "string", false
    //       if(cId==entry.id){
    //         cId=entry.cName;
    //         break;
    //       }
    //     }
    //     if(cId==0){
    //       cId="";
    //     }
    //     return h("span", cId);
    //   },
    // },
    {
      title: "用户名称或电子邮件",
      width:200,
      key: "userNameOrEmailAddress",
    },
    {
      title: "客户端IP地址",
      width:180,
      key: "clientIpAddress",
    },
    // {
    //   title: "客户",
    //   key: "clientName",
    // },
    {
      title: "浏览信息",
      key: "browserInfo",
    },
    // {
    //   title: "结果",
    //   key: "result",
    // },
    {
      title: "创建时间",
      width:180,
      key: "creationTime",
             render: (h, params) => {
        let creationTime ='';
        
        creationTime=this.GetDay(params.row.creationTime) + " "+this.GetMinutes(params.row.creationTime);
        return h("span", creationTime);
      },
    }
  ];
  
 
 created() {
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }

    this.getpage();
    
  }
}
